import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  readPDFFile,
  renderPDFPage,
  getFileExtension,
  saveFile,
  isNumeric,
  renderPDFPages,
  downloadMultipleFiles,
  stitchMultipleImagesToSingleImage,
} from "../Utils";
import PDFViewerView from "../pdf_viewer/PDFViewerView";

function Pdf2ImagePDFListScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);

  //fileinfo list
  //store thumbnail, index etc key is filepath
  const [pdfInfo, setPdfInfo] = useState({
    state: AppState.NONE,
    thumbnail: null,
    pageCount: 0,
    selectedPages: { indices: [], message: "No pages selected." },
    message: "",
    locked: false,
    password: "",
    name: "---",
    file: null, //selected file
    size: 0, //in bytes
    zip_blob: null,
    zip_size: 0,
  });

  //item displaying in password input modal
  const [selectedItemForPasswordInput, setSelectedItemForPasswordInput] =
    useState(null);
  //set images filename
  const [imagefileFilename, setImagefileFilename] = useState("extracted");
  //password input modal input field reference
  //get password value
  const passwordInputModalInputRef = useRef(null);
  //is converting
  const [isConverting, setIsConverting] = useState(false);
  //export configuratiom
  const [exportConfigaration, setExportConfigaration] = useState({
    export_as: ".jpg",
    mimetype: "image/jpg",
    exportasPopupShowing: false,
    singleImage: false,
  });

  //show pdf preview
  const [showPDFPreview, setShowPDFPreview] = useState({
    preview: false,
    file: null,
    password: "",
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //check
      if (selectedFiles.length > 0) {
        //process pdf file
        processPDFFile(selectedFiles[0], "");
      }

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    //check
    //if locked and password not set
    if (pdfInfo.locked === true && pdfInfo.password === "") {
      //show password field
      setSelectedItemForPasswordInput(selectedFiles[0]);
      //click to focus modal
      document.getElementById("passwordModal").click();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles, pdfInfo]);

  //fetch pdf file as data
  //get thumbnail
  //chek if password protected
  //unlock if provided correct password
  //render file
  const processPDFFile = async (selectedFile, password) => {
    //try - catch
    try {
      //read pdf file
      const data = await readPDFFile(selectedFile);
      //thumbnail
      await renderPDFPage(data, password, "image/jpeg", 0.2, 0).then(
        ([img, numPages]) => {
          //set pdf info
          setPdfInfo({
            ...pdfInfo,
            state: AppState.LOADED,
            thumbnail: img,
            pageCount: numPages,
            message: "",
            locked: false,
            password: password,
            name: selectedFile.name,
            file: selectedFile, //selected file
            size: selectedFile.size, //in bytes
            zip_blob: selectedFile, //if no selection provided return original
            zip_size: selectedFile.size,
          });
        },
      );
    } catch (e) {
      //check
      if (e.name === "PasswordException") {
        //set pdf info
        setPdfInfo({
          ...pdfInfo,
          state: AppState.LOADED,
          pageCount: 0,
          message: "",
          locked: true,
          password: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          zip_blob: selectedFile, //if no selection provided return original
          zip_size: selectedFile.size,
        });
      } else {
        //set pdf info
        setPdfInfo({
          ...pdfInfo,
          state: AppState.LOADED,
          pageCount: 0,
          message: "Can not load file. Something went wrong.",
          locked: false,
          password: "",
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
          zip_blob: selectedFile, //if no selection provided return original
          zip_size: selectedFile.size,
        });
      }
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setPdfInfo({
      ...pdfInfo,
      state: AppState.NONE,
      thumbnail: null,
      pageCount: 0,
      selectedPages: { indices: [], message: "No pages selected." },
      message: "",
      locked: false,
      password: "",
      name: "---",
      file: null, //selected file
      size: 0, //in bytes
      zip_blob: null,
      zip_size: 0,
    });
    setShowEditFileScreen(false);
    setStartProcessingFiles(false);
    setExportConfigaration({
      ...exportConfigaration,
      export_as: ".jpg",
      mimetype: "image/jpg",
      exportasPopupShowing: false,
    });
  };

  //on chnage checkbox values
  const onChangeCheckboxValues = (e) => {
    //set
    setExportConfigaration({
      ...exportConfigaration,
      singleImage: e.target.id === "singleImage" ? true : false,
    });
  };

  //on  filename value changed
  const onFilenameValueChanged = (e) => {
    //set values
    setImagefileFilename(e.target.value);
  };

  //on  selectiontext value changed
  const onSelectiontextValueChanged = (e) => {
    //message
    var message = "";
    //page indices
    var pageIndices = [];
    //selectiontext
    const selectiontext = String(e.target.value);

    //split with ,
    const parts = selectiontext.split(",");
    //loop
    for (let i = 0; i < parts.length; i++) {
      //check for empty
      //string
      if (parts[i] === "") {
        //continue
        continue;
      }
      //check
      //break with -
      const rangeParts = parts[i].split("-");
      //check
      if (rangeParts.length === 1) {
        //check if number
        if (isNumeric(parts[i]) === true) {
          //set
          //-1 as index = pagenumber - 1
          pageIndices.push(
            Number(Math.min(pdfInfo.pageCount - 1, Math.max(0, parts[i] - 1))),
          );
        } else {
          //set message
          message = `${parts[i]} is not a valid number`;
        }
      } else if (rangeParts.length === 2) {
        //start
        var start = rangeParts[0];
        var end = rangeParts[1];
        //check
        if (isNumeric(start) === false || isNumeric(end) === false) {
          //message
          //set message
          message = `invalid declaration ${parts[i]}`;
        } else {
          //clamp start to range
          start = Math.min(rangeParts[0] - 1, rangeParts[1] - 1);
          start = Math.max(0, start);
          start = Math.min(start, pdfInfo.pageCount - 1);
          //clamp end to range
          end = Math.max(rangeParts[0] - 1, rangeParts[1] - 1);
          end = Math.max(0, end);
          end = Math.min(end, pdfInfo.pageCount - 1);

          //add indices
          for (var j = start; j <= end; j++) {
            //push
            //set
            pageIndices.push(Number(j));
          }
        }
      } else {
        //set message
        message = `Can't interpret ${parts[i]}`;
      }
    }

    //set selected pages
    setPdfInfo({
      ...pdfInfo,
      selectedPages: { indices: pageIndices, message: message },
    });
  };

  //render password input modal
  const renderPassordInputModal = (item) => {
    return (
      <div
        className="modal fade"
        id="passwordInputModal"
        tabIndex="-1"
        aria-labelledby="passwordInputModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="passwordInputModalLabel">
                {item !== null ? item.name : "Failed loading file"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="password" className="col-form-label">
                    Unlock pdf to continue. Enter password below:
                  </label>
                  <input
                    type="password"
                    className="form-control mt-2"
                    id="password"
                    placeholder="Type password here..."
                    ref={passwordInputModalInputRef}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={(e) => {
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                  //process pdf
                  processPDFFile(item, pdfInfo.password);
                }}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={async (e) => {
                  //process file
                  await processPDFFile(
                    item,
                    passwordInputModalInputRef.current.value,
                  );
                  //clear reference value
                  passwordInputModalInputRef.current.value = null;
                }}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        data-bs-toggle={`${pdfInfo.locked === true ? "modal" : ""}`}
        data-bs-target={`${
          pdfInfo.locked === true ? "#passwordInputModal" : ""
        }`}
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //check
          //if locked
          if (pdfInfo.locked === true) {
            //show password field
            //set item
            setSelectedItemForPasswordInput(item);
          } else {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: true,
              file: pdfInfo.file,
              password: pdfInfo.password,
            });
          }
        }}
      >
        {/* Flex container left image pdf right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  pdfInfo.thumbnail != null
                    ? pdfInfo.thumbnail
                    : "./images/file_icon.png"
                }
                alt="pdf_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size:{" "}
                {pdfInfo.state === AppState.PROCESSED
                  ? formatBytes(pdfInfo.zip_size)
                  : formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  pdfInfo.state === AppState.PROCESSED
                    ? "text-success"
                    : "bg-danger text-white"
                }`}
              >
                {pdfInfo.state === AppState.PROCESSED
                  ? "EXTRACTED"
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {pdfInfo.state === AppState.PROCESSED
                ? pdfInfo.selectedPages.indices.length
                : pdfInfo.pageCount === undefined
                  ? "__"
                  : pdfInfo.pageCount}{" "}
              Pages
            </div>
            {/* Lock Message */}
            <div
              className={`px-2 text-danger fs-6 mt-3 fw-bold ${
                pdfInfo.locked === true ? "" : "d-none"
              }`}
            >
              Locked. Click to unlock.
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                pdfInfo.message !== "" ? "" : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {pdfInfo.message}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          {/* Download Button */}
          {/* Show download button after processed */}
          <div
            className="position-absolute  justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            <div
              className={`my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.PROCESSED ? "" : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={async (e) => {
                  //stop propagating
                  e.stopPropagation();
                  //blob
                  const blob = pdfInfo.zip_blob;
                  // Use file-saver to save the generated zip file
                  await saveFile(blob, `extracted_${imagefileFilename}.zip`);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-download"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                </svg>
              </button>
            </div>
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.PROCESSING ? "" : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                pdfInfo.state === AppState.LOADED ||
                pdfInfo.state === AppState.NONE
                  ? ""
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="position-relative">
      {/* show pdf preview */}
      {/* page main content */}
      {showPDFPreview.preview ? (
        <PDFViewerView
          title={showPDFPreview.file === null ? "" : showPDFPreview.file.name}
          password={showPDFPreview.password}
          onClose={() => {
            //set preview
            setShowPDFPreview({
              ...showPDFPreview,
              preview: false,
              file: null,
              password: "",
            });
          }}
          file={showPDFPreview.file}
        ></PDFViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
            data-bs-toggle={`${pdfInfo.locked ? "modal" : ""}`}
            data-bs-target={`${pdfInfo.locked ? "#passwordInputModal" : ""}`}
            id="passwordModal"
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Label filename input */}
              <div>
                <label
                  htmlFor="mergedFilename"
                  className="form-label mt-5 ms-4 fs-4 text-dark"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Output filename"
                >
                  Output filename:
                </label>
                <input
                  type="text"
                  className="form-control ms-4 mt-3 me-4"
                  id="filenameInput"
                  aria-describedby="filename"
                  placeholder="Output filename (xyz)"
                  onChange={onFilenameValueChanged}
                  style={{ width: "calc(100% - 48px)" }}
                />
              </div>

              {/* Selection */}
              <div className="w-100 ms-4 mt-5 border-top pt-3">
                {/* Title */}
                <label
                  className="fs-4"
                  title="Choose the pages you want to export as image. Enter page numbers separated by commas (example: 1,2,3 etc), or select a range using a start page number and an end page number (example: [1-100])."
                >
                  Selection:
                </label>
                {/* Selection text*/}
                <input
                  type="text"
                  className="form-control mt-3 me-4"
                  id="selectionInput"
                  aria-describedby="selecttext"
                  placeholder="1,2,3,4-9 pages"
                  onChange={onSelectiontextValueChanged}
                  style={{ width: "calc(100% - 48px)" }}
                />
                {/* Message */}
                <label
                  className={`fs-6 mt-3 text-danger ${
                    pdfInfo.selectedPages.message === ""
                      ? "d-none"
                      : pdfInfo.selectedPages.message
                  }`}
                  style={{
                    width: "calc(100% - 48px)",
                  }}
                >
                  {pdfInfo.selectedPages.message}
                </label>
              </div>

              {/* Settings */}
              <div className="w-100 ms-4 mt-4 border-top pt-3">
                {/* Title */}
                <label className="fs-4">Settings:</label>
                {/* Number of pages */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Export as:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenu"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setExportConfigaration({
                          ...exportConfigaration,
                          exportasPopupShowing:
                            exportConfigaration.exportasPopupShowing === true
                              ? false
                              : true,
                        });
                      }}
                    >
                      {exportConfigaration.export_as}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        exportConfigaration.exportasPopupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenu"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".jpg",
                            mimetype: "image/jpg",
                          });
                        }}
                      >
                        .jpg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".jpeg",
                            mimetype: "image/jpeg",
                          });
                        }}
                      >
                        .jpeg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".png",
                            mimetype: "image/png",
                          });
                        }}
                      >
                        .png
                      </button>{" "}
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".bmp",
                            mimetype: "image/bmp",
                          });
                        }}
                      >
                        .bmp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".webp",
                            mimetype: "image/webp",
                          });
                        }}
                      >
                        .webp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setExportConfigaration({
                            ...exportConfigaration,
                            exportasPopupShowing: false,
                            export_as: ".svg",
                            mimetype: "image/svg+xml",
                          });
                        }}
                      >
                        .svg
                      </button>
                    </div>
                  </div>
                </div>

                {/* Export as single image */}
                {/* Checkbox single image */}
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    checked={exportConfigaration.singleImage}
                    id="singleImage"
                    onChange={onChangeCheckboxValues}
                  />
                  <label
                    className="form-check-label ms-2 text-secondary"
                    htmlFor="singleImage"
                  >
                    Single Image (max: 20,000px)
                  </label>
                </div>

                {/* Export as multiple image */}
                {/* Checkbox multiple image */}
                <div className="form-check mt-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    checked={exportConfigaration.singleImage ? false : true}
                    id="multipleImage"
                    onChange={onChangeCheckboxValues}
                  />
                  <label
                    className="form-check-label ms-2 text-secondary"
                    htmlFor="multipleImage"
                  >
                    Individual Image (.zip)
                  </label>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isConverting ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                  lineHeight: "1.1",
                }}
                type="button"
                onClick={async (e) => {
                  //blur
                  e.currentTarget.blur();
                  console.log("output filename: ", imagefileFilename);

                  //check
                  //if indices not defined
                  //return
                  if (selectedFiles.length === 0) {
                    //return
                    return;
                  }

                  //set
                  setIsConverting(true);
                  //render pdf pages
                  //at given indexes
                  //try catch
                  try {
                    //read pdf file
                    const data = await readPDFFile(selectedFiles[0]);
                    //page images
                    //extract pages as image
                    const [images] = await renderPDFPages(
                      data,
                      pdfInfo.password,
                      exportConfigaration.mimetype,
                      1.0,
                      false,
                      false,
                      pdfInfo.selectedPages.indices, //render all pages
                      (perct) => {
                        //set state
                        setPdfInfo({
                          ...pdfInfo,
                          state: AppState.PROCESSING,
                          message: `Reading file ${Math.floor(perct * 100)}%`,
                        });
                      },
                    );

                    //check
                    var blob = null;

                    //check
                    if (exportConfigaration.singleImage === false) {
                      //set
                      //set blob
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSING,
                        message: `Zipping...`,
                      });

                      //zip images
                      blob = await downloadMultipleFiles(
                        images,
                        imagefileFilename,
                        "STORE",
                      );
                    } else {
                      //set
                      //set blob
                      setPdfInfo({
                        ...pdfInfo,
                        state: AppState.PROCESSING,
                        message: `Stitching...`,
                      });

                      //stitch all images
                      blob = await stitchMultipleImagesToSingleImage(
                        images,
                        exportConfigaration.mimetype,
                        20000, //in px
                        20000, //in px
                      );
                    }

                    //set
                    //set blob
                    setPdfInfo({
                      ...pdfInfo,
                      state: AppState.PROCESSED,
                      message: `Successfully extracted. Extracted images will be downloaded automatically on your device.`,
                      zip_blob: blob,
                      zip_size: blob === null ? 0 : blob.size,
                    });

                    // Use file-saver to save the generated zip file
                    await saveFile(blob, `extracted_${imagefileFilename}.zip`);
                  } catch (e) {}
                  //read pdf file
                  //reset
                  setIsConverting(false);
                }}
              >
                EXTRACT
                <br />
                <span className="fs-6">Extract images from selected pages</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Password input modal */}
      {renderPassordInputModal(selectedItemForPasswordInput)}
    </div>
  ); //show hide loading view
}

export default Pdf2ImagePDFListScreen;
